import axios from "axios";
import {
  DOCTOR_LIST_REQUEST,
  DOCTOR_LIST_SUCCESS,
  DOCTOR_LIST_FAIL,
  PATIENT_VISITS_DETAIL_REQUEST,
  PATIENT_VISITS_DETAIL_SUCCESS,
  PATIENT_VISITS_DETAIL_FAIL,
  HOSPITAL_LIST_REQUEST,
  HOSPITAL_LIST_SUCCESS,
  HOSPITAL_LIST_FAIL,
  NOTIFICATIONS_REQUEST,
  NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_FAIL,
  READ_NOTIFICATION_REQUEST,
  READ_NOTIFICATION_SUCCESS,
  READ_NOTIFICATION_FAIL,
  MARK_ALL_NOTIFICATIONS_READ_REQUEST,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_FAIL,
  RESEARCH_STUDY_MENU_REQUEST,
  RESEARCH_STUDY_MENU_SUCCESS,
  RESEARCH_STUDY_MENU_FAIL,
  HARDWARE_LIST_REQUEST,
  HARDWARE_LIST_SUCCESS,
  HARDWARE_LIST_FAIL,
  HARDWARE_DETAILS_REQUEST,
  HARDWARE_DETAILS_SUCCESS,
  HARDWARE_DETAILS_FAIL,
  FIRMWARE_LIST_REQUEST,
  FIRMWARE_LIST_SUCCESS,
  FIRMWARE_LIST_FAIL,
  FIRMWARE_DETAILS_REQUEST,
  FIRMWARE_DETAILS_SUCCESS,
  FIRMWARE_DETAILS_FAIL,
} from "../constants/doctorConstants";

export const listDoctors = () => async (dispatch) => {
  try {
    dispatch({ type: DOCTOR_LIST_REQUEST });
    const { data } = await axios.get(`http://127.0.0.1:8000/doc/docs/`);

    dispatch({
      type: DOCTOR_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DOCTOR_LIST_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};

export const getPatientVisitsDetail = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: PATIENT_VISITS_DETAIL_REQUEST });

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/patient_visit_detail_v1/${id}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    dispatch({
      type: PATIENT_VISITS_DETAIL_SUCCESS,
      payload: data.data,
    });
    return data.data;
  } catch (error) {
    dispatch({
      type: PATIENT_VISITS_DETAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

export const getHospitalList = (token) => async (dispatch) => {
  try {
    dispatch({ type: HOSPITAL_LIST_REQUEST });

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/hospital`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    dispatch({
      type: HOSPITAL_LIST_SUCCESS,
      payload: data.data,
    });
    return data.data;
  } catch (error) {
    dispatch({
      type: HOSPITAL_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

export const getNotifications = (token) => async (dispatch) => {
  try {
    dispatch({ type: NOTIFICATIONS_REQUEST });

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/notifications`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    dispatch({
      type: NOTIFICATIONS_SUCCESS,
      payload: data.data,
    });
    return data.data;
  } catch (error) {
    dispatch({
      type: NOTIFICATIONS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

export const readNotification = (id, token) => async (dispatch) => {
  try {
    dispatch({ type: READ_NOTIFICATION_REQUEST });

    const { data } = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/notifications/mark-read`,
      {
        notification_id: id,
      },
      {
        headers: {
          "Content-type": "application/json",
          Authorization: `${token}`,
        },
      }
    );
    dispatch({
      type: READ_NOTIFICATION_SUCCESS,
      payload: data.data,
    });
    return data.data;
  } catch (error) {
    dispatch({
      type: READ_NOTIFICATION_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

export const markAllReadNotifications = (token) => async (dispatch) => {
  try {
    dispatch({ type: MARK_ALL_NOTIFICATIONS_READ_REQUEST });

    const { data } = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/notifications`,
      {},
      {
        headers: {
          "Content-type": "application/json",
          Authorization: `${token}`,
        },
      }
    );
    dispatch({
      type: MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
      payload: data.data,
    });
    return data.data;
  } catch (error) {
    dispatch({
      type: MARK_ALL_NOTIFICATIONS_READ_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

export const getResearchStudyMenu = (token) => async (dispatch) => {
  try {
    dispatch({ type: RESEARCH_STUDY_MENU_REQUEST });

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/research-menu`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    dispatch({
      type: RESEARCH_STUDY_MENU_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    dispatch({
      type: RESEARCH_STUDY_MENU_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
    throw error;
  }
};

export const uploadDevice = (sanitizedData, token) => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/devices/`,
      sanitizedData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Something went wrong.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "object") {
        const fieldErrors = Object.entries(resData.message)
          .map(([field, messages]) => `${messages.join(", ")}`)
          .join("\n");
        errorMessage = fieldErrors;
      } else if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const updateUploadDevice = (sanitizedData, token, id) => async () => {
  try {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/device/${id}/`,
      sanitizedData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Something went wrong.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "object") {
        const fieldErrors = Object.entries(resData.message)
          .map(([field, messages]) => `${messages.join(", ")}`)
          .join("\n");
        errorMessage = fieldErrors;
      } else if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const hardwareDevices = (token) => async (dispatch) => {
  try {
    dispatch({ type: HARDWARE_LIST_REQUEST });

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/devices/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: HARDWARE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: HARDWARE_LIST_FAIL,
      payload: errorMessage,
    });
  }
};

export const getHardwareById = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: HARDWARE_DETAILS_REQUEST });

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/device/${id}/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: HARDWARE_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: HARDWARE_DETAILS_FAIL,
      payload: errorMessage,
    });
    throw new Error(errorMessage);
  }
};

export const deleteHardware = (token, id) => async (dispatch) => {
  try {
    // dispatch({ type: HARDWARE_DELETE_REQUEST });

    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/device/${id}/`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    // dispatch({
    //   type: HARDWARE_DELETE_SUCCESS,
    //   payload: data,
    // });
    return data;
  } catch (error) {
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    // dispatch({
    //   type: HARDWARE_DELETE_FAIL,
    //   payload: errorMessage,
    // });
    throw new Error(errorMessage);
  }
};

// Firmware Actions
export const uploadFirmware = (firmwareData, token) => async () => {
  try {
    const formData = new FormData();
    Object.keys(firmwareData).forEach((key) => {
      formData.append(key, firmwareData[key] || "");
    });

    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/firmware/upload`,
      formData,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Something went wrong.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.mfa_required) {
        const mfaError = new Error(
          resData.message || "MFA verification required before firmware upload."
        );
        mfaError.mfaRequired = true;
        mfaError.mfaSetupRequired = !!resData.mfa_setup_required;
        throw mfaError;
      }
      if (resData.message && typeof resData.message === "object") {
        const fieldErrors = Object.entries(resData.message)
          .map(([field, messages]) => `${messages.join(", ")}`)
          .join("\n");
        errorMessage = fieldErrors;
      } else if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const verifyFirmwareMfa = (code, token) => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/mfa/verify`,
      { code },
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "MFA verification failed.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.data && typeof resData.data === "object") {
        errorMessage = Object.values(resData.data).flat().join(" ");
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const getFirmwareMfaStatus = (token) => async () => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/mfa/status`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Unable to fetch authenticator status.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const sendFirmwareMfaSetupEmail = (token) => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/mfa/setup/email/send`,
      {},
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Unable to send verification email.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const verifyFirmwareMfaSetupEmail = (code, token) => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/mfa/setup/email/verify`,
      { code },
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Email verification failed.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.data && typeof resData.data === "object") {
        errorMessage = Object.values(resData.data).flat().join(" ");
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const enableFirmwareMfaSetup = (token) => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/mfa/enable`,
      {},
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Unable to start authenticator setup.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const verifyFirmwareMfaSetup = (code, token) => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/mfa/setup/verify`,
      { code },
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Authenticator setup verification failed.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.data && typeof resData.data === "object") {
        errorMessage = Object.values(resData.data).flat().join(" ");
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const updateFirmware = (firmwareData, token, id) => async () => {
  try {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/firmware/${id}`,
      firmwareData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    let errorMessage = "Something went wrong.";
    if (error.response) {
      const resData = error.response.data;
      if (resData.message && typeof resData.message === "object") {
        const fieldErrors = Object.entries(resData.message)
          .map(([field, messages]) => `${messages.join(", ")}`)
          .join("\n");
        errorMessage = fieldErrors;
      } else if (resData.message && typeof resData.message === "string") {
        errorMessage = resData.message;
      } else if (resData.detail) {
        errorMessage = resData.detail;
      }
    } else {
      errorMessage = error.message;
    }
    throw new Error(errorMessage);
  }
};

export const firmwareList = (token) => async (dispatch) => {
  try {
    dispatch({ type: FIRMWARE_LIST_REQUEST });

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/firmware/list-all`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: FIRMWARE_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: FIRMWARE_LIST_FAIL,
      payload: errorMessage,
    });
  }
};

export const getFirmwareById = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: FIRMWARE_DETAILS_REQUEST });

    const { data } = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/firmware/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({
      type: FIRMWARE_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: FIRMWARE_DETAILS_FAIL,
      payload: errorMessage,
    });
    throw new Error(errorMessage);
  }
};

export const deleteFirmware = (token, id) => async (dispatch) => {
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/firmware/${id}`,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    throw new Error(errorMessage);
  }
};
